import { PAYMENT_TYPES } from '@/constants/paymentTypes'

export const STATUSES = {
    NEW: 'new',
    EDITING: 'editing',
    WAITING_START_COOKING: 'waiting_start_cooking',
    SENT_TO_DIVISION: 'sent_to_division',
    COOKING: 'cooking',
    SEND_ERROR: 'send_error',
    DRAFT: 'draft',
    COMPLETED: 'completed',
    DELIVERED: 'delivered',
    ON_THE_WAY: 'on_the_way',
    CANCELED: 'canceled',
    COLLECTED: 'collected',
    CANCELED_BY_MANAGER: 'canceled_by_manager',
    NO_PRINTED_INVOICE: 'no_printed_invoice',
}

export const STAGES = {
    DRAFT: 0,
    NEW: 2,
    EDITING: 3,
    WAITING_START_COOKING_OR_CANCELLED: 4,
    SENT_TO_DIVISION: 5,
    PRE_FINAL: 6, // Статусы: Начали готовить, Собран, В пути, Ошибка отправки
    FINAL: 7, // Статусы: Доставлен, Исполнен, Отменен менеджером
}

export const FOREMAN_FILTER_STATUSES = [
    {
        id: STATUSES.WAITING_START_COOKING,
        name: 'Ждет начала приготовления',
        color: '#00CFE8',
    },

    {
        id: STATUSES.SENT_TO_DIVISION,
        name: 'Отправлен в подразделение',
        color: '#00CFE8',
    },
    {
        id: STATUSES.COOKING,
        name: 'Начали готовить',
        color: '#28C76F',
    },
    {
        // id: 'collected',
        id: STATUSES.COLLECTED,
        name: 'Собран',
        color: '#FF9F43',
    },
    {
        // id: 'on_the_way',
        id: STATUSES.ON_THE_WAY,
        name: 'В пути',
        color: '#28C76F',
    },
    {
        // id: 'delivered',
        id: STATUSES.DELIVERED,
        name: 'Доставлен',
        color: '#4B465C14',
    },
    {
        // id: 'completed',
        id: STATUSES.COMPLETED,
        name: 'Исполнен',
        color: '#2F3349',
    },
    {
        // id: 'send_error',
        id: STATUSES.SEND_ERROR,
        name: 'Ошибка отправки',
        color: '#EA545514',
    },
    {
        // id: 'canceled',
        id: STATUSES.CANCELED,
        name: 'Отменен',
        color: '#EA545514',
    },
    {
        // id: 'canceled_by_manager',
        id: STATUSES.CANCELED_BY_MANAGER,
        name: 'Отменен менеджером',
        color: '#EA545514',
    },
    {
        // id: 'no_printed_invoice',
        id: STATUSES.NO_PRINTED_INVOICE,
        name: 'Не распечатана счет-фактура',
        color: '#FF9F43',
    },
]

export const COURIER_STATUSES = {
    AVAILABLE: 'available',
    ON_WAY: 'on_way',
}

export const ORDER_COPY_BLOCKING_STATUSES = [
    'Доставлен',
    'Исполнен',
    'Отменен',
    'Отменен менеджером',
]

export const ORDER_COPY_BLOCKING_PAYMENT_TYPES = [
    PAYMENT_TYPES.ONLINE,
    PAYMENT_TYPES.ONLINE_CHANGE,
    PAYMENT_TYPES.ONLINE_TRANSACTION,
    PAYMENT_TYPES.INVOICE_BOX,
    PAYMENT_TYPES.SBP_COURIER,
    PAYMENT_TYPES.PAYMENT_UNDER_CONTRACT,
    PAYMENT_TYPES.GIFT_CARD,
    PAYMENT_TYPES.PREORDER,
]

export const ORDER_COPY_ON_BASIS_BLOCKING_PAYMENT_TYPES = [
    PAYMENT_TYPES.GIFT_CARD,
    PAYMENT_TYPES.PREORDER,
]

export const ORDER_ALLOWED_TRANSACTION_ID_PAYMENT_TYPES = [
    PAYMENT_TYPES.ONLINE,
    PAYMENT_TYPES.ONLINE_CHANGE,
    PAYMENT_TYPES.ONLINE_TRANSACTION,
    PAYMENT_TYPES.SBP_COURIER,
    PAYMENT_TYPES.INVOICE_BOX,
    PAYMENT_TYPES.PREORDER,
]

export const MAIN_TRANSACTION_EDITABLE_STATUSES = [
    STATUSES.DRAFT,
    STATUSES.NEW,
    STATUSES.EDITING,
]

export const INVOICE_PRINT_BLOCKING_STATUSES = [
    STATUSES.WAITING_START_COOKING,
    STATUSES.SENT_TO_DIVISION,
    STATUSES.SEND_ERROR,
    STATUSES.CANCELED_BY_MANAGER,
]

export const FISCAL_INVOICE_PRINT_BLOCKING_STATUSES = [
    STATUSES.CANCELED,
    STATUSES.WAITING_START_COOKING,
    STATUSES.SENT_TO_DIVISION,
    STATUSES.SEND_ERROR,
    STATUSES.CANCELED_BY_MANAGER,
]

export const CANCEL_FISCAL_INVOICE_BLOCKING_STATUSES = [
    STATUSES.WAITING_START_COOKING,
    STATUSES.SENT_TO_DIVISION,
]

export const FORBID_SAVE_ORDER_STATUSES = [
    STATUSES.COMPLETED,
    STATUSES.CANCELED,
    STATUSES.CANCELED_BY_MANAGER,
]

export const FORBID_CANCEL_ORDER_STATUSES = [STATUSES.CANCELED_BY_MANAGER]
